import { render } from "./RepresentativeStep.vue?vue&type=template&id=33584d09"
import script from "./RepresentativeStep.vue?vue&type=script&lang=ts"
export * from "./RepresentativeStep.vue?vue&type=script&lang=ts"
script.render = render

export default script